import { ArrowDown, ArrowRight, ClipboardList, Settings2, Sparkles } from "lucide-react";

const STEPS = [
  { number: "01", icon: ClipboardList, title: "Tell us about your business", copy: "Provide your business details, products, customers and preferences." },
  { number: "02", icon: Settings2, title: "We set up FlowSphere", copy: "Our team configures your account based on the information you provide." },
  { number: "03", icon: Sparkles, title: "Start running your business", copy: "Log in and start invoicing, tracking inventory, recording payments and understanding your finances." },
];

export const ConciergeProcess = () => (
  <section className="process-section" id="how-it-works" data-testid="concierge-process-section">
    <div className="section-kicker">THE CONCIERGE DIFFERENCE</div>
    <div className="process-intro">
      <h2 data-testid="process-heading">Don’t spend your day<br />configuring software.</h2>
      <p data-testid="process-supporting-copy">Tell us how your business works. Our team will configure FlowSphere System around your business so you can start using it without the usual setup headache.</p>
    </div>
    <div className="process-track">
      {STEPS.map((step, index) => {
        const Icon = step.icon;
        return <div className="process-item" key={step.number}>
          <article className="process-card" data-testid={`process-step-${step.number}`}>
            <div className="process-number">{step.number}</div><Icon size={25} />
            <h3>{step.title}</h3><p>{step.copy}</p>
          </article>
          {index < STEPS.length - 1 && <div className="process-connector" aria-hidden="true"><ArrowRight className="desktop-arrow" size={19} /><ArrowDown className="mobile-arrow" size={19} /></div>}
        </div>;
      })}
    </div>
  </section>
);